import styled, { css, keyframes } from 'styled-components';

import { resetButton } from 'styles/common';

export const Root = styled.button`
  ${resetButton}
  width: 22px;
  height: 22px;
  border-radius: 8px;
  transition: background-color 0.15s;

  &:disabled {
    cursor: default;
  }
`;

const updateProgress = keyframes`
  0% {
    stroke-dasharray: 0 101;
  }
  99% {
    stroke-dasharray: 97 101;
  }
`;

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Сircumference: C = 2 π ⋅ r
// C = 2 * 3.14 * 16px = 100.48px
// End of loader svg arrow is 97px. It is finish of animation

export const Loader = styled.div<{
  $updateTimeSec: number | null;
  $isLoading: boolean;
}>`
  width: 100%;
  height: 100%;
  mask-image: url('/images/icons/loader.svg');
  mask-position: center;
  mask-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  opacity: ${(props) => (!props.$isLoading && !props.$updateTimeSec ? 0.6 : 1)};

  svg {
    background: rgba(255, 255, 255, 0.7);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-91deg);
    fill: none;
    stroke: rgba(155, 89, 182);
    stroke-dasharray: 0 101;
    transition: background-color 0.15s;

    ${({ $updateTimeSec }) =>
      $updateTimeSec &&
      css`
        animation: ${updateProgress} ${$updateTimeSec}s linear infinite;
      `}
  }

  &:hover svg {
    background: rgba(255, 255, 255, 0.9);
  }

  ${({ $isLoading }) =>
    $isLoading &&
    css`
      animation: ${rotate} 1.2s linear infinite;
    `}
`;
